export class Column {
  constructor(
    public key: string,
    public title: string,
  ) {}
}
